import type { Plugin } from 'vue';
import { noop } from 'lodash-es';
import { useEventBus } from '@/app/core/event-bus';
import { useAnnouncementsStore } from './stores';

export function createAnnouncements(): Plugin {
  return {
    install() {
      const store = useAnnouncementsStore();
      const eventBus = useEventBus();

      eventBus.on('appInitialized', () => {
        store.fetch().catch(noop);
      });
    },
  };
}

export * from './components';
export * from './stores';
